import React, {Component} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { Button, FormField, Spinner } from 'components'

import * as actionCreators from 'store/actions'
import * as api from 'api'

const Container = styled.div`
    margin: 0.5rem 0;
    width: 100%;
`

const Error = styled.div`
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: var(--error-color);
`

const Success = styled.div`
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: var(--success-color);
`

const Back = styled.div`
    color: var(--text-color);
    font-weight: bolder;
    font-size: 0.8rem;
    margin-top: 1rem;
    text-align: center;
`

class ForgotPasswordScreen extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            selection: null,
            errors: {
                email: null
            }
        }
    }

    onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            this.submitForm()
        } 
    }

    submitForm() {
        // Email
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!this){
            return
        }
        if(!this.state.email){
            this.setState({ submit: false, error: 'Please enter your email', success: null})
        } else if (!re.test(this.state.email)){
            this.setState({ submit: false, error: 'Please enter a valid email', success: null})
        } else {
            this.setState({ submit: true })
            // this.props.resetPassword(this.state.email)
            api.resetPassword({email: this.state.email})
            .then(res => {
                console.log('Reset password email sent')
                this.setState({ submit: false, error: null, success: 'Please click on the link sent to your email to reset your password'})
            })
            .catch(err => {
                console.log('Reset password email not sent', err)
                if(err.code === 'auth/user-not-found'){
                    this.setState({ submit: false, error: null, success: 'Please click on the link sent to your email to reset your password' })
                } else {
                    const errorMessage = err.code === 'auth/too-many-requests' ? 'Please try again later'
                                        : 'Something went wrong'
                    this.setState({ submit: false, error: errorMessage, success: null })
                }
            })
        } 
    }
    
    render(){
        const showSpinner = this.state.submit
        return(
            <Container>
                <FormField type='TEXT' label='Email' value={this.state.email} error={!this.state.success && this.state.error} success={this.state.success}
                    selected={this.state.selection === 'EMAIL'} onKeyDown={this.onKeyDownHandler}
                    onChange={(value) => {this.setState({email: value})}} onFocus={() => this.setState({selection: 'EMAIL'})} onBlur={() => this.setState({selection: null})}/>

                <Button text={!showSpinner && 'Submit'} icon={showSpinner && <Spinner styles={{color: 'var(--text-color)'}}/>}
                    onSelect={this.submitForm}
                    styles={{backgroundColor: 'var(--focus-color)', height: '1.2rem', margin: '1rem 0 0 0', fontWeight: 'bolder'}}/>

                <NavLink to='/login' exact><Back>Back to login</Back></NavLink>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        success: state.auth.success,
        error: state.auth.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        resetPassword: (email) => dispatch(actionCreators.resetPassword(email)),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ForgotPasswordScreen ); 